import Color from 'color'
import { primitiveColor } from 'helpers/designSystem/primitiveColor'
import { colorTokens, ColorTokens } from 'helpers/designSystem/colorTokens'

export interface ColorPalette extends ColorTokens {
  gray100: string
  gray400: string
  gray300: string
  gray600: string
  gray700: string
  gray800: string
  gray900: string
  volcano600: string
  volcano100: string
  volcano200: string
  volcano500: string
  lime800: string
  green100: string
  green200: string
  green300: string
  green400: string
  green500: string
  green800: string
  lime700: string
  gold600: string
  orange100: string
  gold500: string
  blue300: string
  lightBlueBg: string
  blue100: string
  cyan400: string
  purple200: string
  hatoTertiary500: string
  gold800: string
  red100: string
  red600: string
  red700: string
  purple100: string
  purple500: string
  primaryHover: string
  second: string
  secondHover: string
  gold100: string
  notice: string
  primary: string
  secondary: string
  secondaryLight: string
  tertiary: string
  highlight: string
  errorLight: string
  errorHover: string
  gold200: string
  warningBg: string
  warningDark: string
  success: string
  white: string
  base: string
  darkGrey: string
  baseGrey: string
  infoDark: string
  infoLight: string
  infoLightWhite: string
  lightGrey: string
  veryLightGrey: string
  lime900: string
  hatoHeartBackground: string
  nutritionBadge: string
  nutritionCalories: string
  nutritionCarbs: string
  nutritionFat: string
  nutritionFiber: string
  nutritionProtein: string
  overlay: string
  overlayDark: string
  textAndBackgroundDark: string
  textAndBackgroundDarkGrey: string
  textAndBackgroundGrey: string
  textAndBackgroundLightGrey: string
  textAndBackgroundWhite: string
  textAndBackgroundWhiteGrey: string
  // only have in Kaikao
  dropdownText: string | null
  dropdownIcon: string | null
}

const base = {
  gray100: '#F5F5F5',
  gray400: primitiveColor.gray400,
  gray300: primitiveColor.gray500,
  gray600: primitiveColor.gray600,
  gray700: primitiveColor.gray700,
  gray800: primitiveColor.gray800,
  gray900: primitiveColor.gray900,
  volcano600: primitiveColor.volcano600,
  volcano100: primitiveColor.volcano100,
  volcano200: primitiveColor.volcano200,
  volcano500: primitiveColor.volcano500,
  lime800: primitiveColor.lime800,
  green100: primitiveColor.green100,
  green200: primitiveColor.green200,
  green300: primitiveColor.green300,
  green400: primitiveColor.green400,
  green500: primitiveColor.green500,
  green800: primitiveColor.green800,
  lime700: primitiveColor.lime700,
  gold600: primitiveColor.gold600,
  orange100: primitiveColor.orange100,
  gold500: primitiveColor.gold500,
  blue300: primitiveColor.blue300,
  lightBlueBg: '#F1F8FB',
  blue100: primitiveColor.blue100,
  cyan400: primitiveColor.cyan400,
  purple200: primitiveColor.purple200,
  hatoTertiary500: primitiveColor.hatoTertiary500,
  gold800: primitiveColor.gold800,
  red100: primitiveColor.red100,
  red600: primitiveColor.red600,
  red700: primitiveColor.red700,
  purple100: primitiveColor.purple100,
  purple500: primitiveColor.purple500,
}

const colors: ColorPalette = {
  primaryHover: Color(primitiveColor.green800).lighten(0.2).hex(),
  second: primitiveColor.lime700,
  secondHover: Color(primitiveColor.lime700).lighten(0.2).hex(),
  gold100: primitiveColor.gold100,
  notice: primitiveColor.gold500,
  ...base,
  ...colorTokens,
  primary: '#0E9755',
  secondary: '#7FB036',
  secondaryLight: '#FDFFFB',
  tertiary: '#76BC21',
  highlight: '#F1F8E8',
  errorLight: primitiveColor.red500,
  errorHover: Color('#EB5757').lighten(0.2).hex(),
  gold200: primitiveColor.gold200,
  warningBg: '#FFFCF3',
  warningDark: '#E87100',
  success: '#4A9500',
  white: '#FFFFFF',
  base: '#333333',
  darkGrey: '#828282',
  baseGrey: '#B9B9B9',
  infoDark: '#1562A8',
  infoLight: '#2E8CE2',
  infoLightWhite: '#F2F9FF',
  lightGrey: '#E0E0E0',
  veryLightGrey: '#F6F6F6',
  lime900: primitiveColor.lime900,
  hatoHeartBackground: '',
  nutritionBadge: '#FEF5E4',
  nutritionCalories: '#FF5733',
  nutritionCarbs: '#AF7A3B',
  nutritionFat: '#FEBE10',
  nutritionFiber: '#C13E30',
  nutritionProtein: '#99D2E2',
  overlay: Color('#333333').alpha(0.56).string(),
  overlayDark: Color('#333333').alpha(0.88).string(),
  textAndBackgroundDark: '#333333',
  textAndBackgroundDarkGrey: '#828282',
  textAndBackgroundGrey: '#B9B9B9',
  textAndBackgroundLightGrey: '#EEEEEE',
  textAndBackgroundWhite: '#FFFFFF',
  textAndBackgroundWhiteGrey: '#F6F6F6',
  dropdownText: null,
  dropdownIcon: null,
}

export default colors
